module.exports = __webpack_public_path__ + "img/80.bae652dc.jpg";